import { Map } from 'immutable';
import { v4 as uuidv4 } from 'uuid';

import Logger from '../../../tools/Logger';
import { ApplicationStateKeys } from '../constants/Application';

const log = Logger.child({
  component: 'domains/application/reducers',
});

const deviceId = '1880';
let uuid;

try {
  uuid = uuidv4();
} catch (error) {
  log.error(error, 'uuidv4() did not generate unique id or somethng went wrong');
}

const INITIAL_STATE = Map({
  [ApplicationStateKeys.DEVICE_UUID]: uuid || deviceId,
  [ApplicationStateKeys.DEVICE_ID]: deviceId,
});

export default function reducer(state = INITIAL_STATE) {
  return state;
}
